<template>
  <!-- 本月数据概况 柱状图 -->
  <div class="chart-bar"/>
</template>

<script>
import * as echarts from 'echarts'
import chartInitMixin from "@/views/mixin/chartInitMixin";

export default {
  name: 'chart-bar',
  props: {
    chartData: {
      type: Object,
      required: true,
    },
  },
  mixins: [
    chartInitMixin
  ],
  data() {
    return {
      color: '#3398DB', // 默认柱状图颜色
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.update()
      }
    },
  },
  methods: {
    update() {
      const {name, value, totle, percentage} = this.chartData
      if (!name) return;
      const option = {
        grid: {
          top: '10px', // 上边距为0
          left: '3%', // 左边距
          right: '3%', // 右边距
          bottom: 0, // 下边距为0
          containLabel: true // 确保标签不会被裁剪
        },
        series: [
          { // 主数据
            z: 3,
            zlevel: 3,
            name: this.chartData.name,
            type: 'gauge',
            center: ['50%', '80%'],
            startAngle: 180,
            endAngle: 0,
            radius: '90%',
            min: 0,
            max: 100,
            splitNumber: 10,
            // color: ['#DD1287'],
            itemStyle: {
              color: '#FAC858',
            },
            pointer: {
              show: false
            },
            progress: {
              show: true,
              width: 12
            },
            axisLine: {
              lineStyle: {
                width: 18,
                color: [
                  [1, 'rgb(82,124,140)']
                ],
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
              distance: 0,
              color: '#00FFF4',
              fontSize: 10,
            },
            anchor: {
              show: false
            },
            title: {
              show: false
            },
            detail: {
              valueAnimation: true,
              width: '10%',
              lineHeight: 20,
              borderRadius: 8,
              offsetCenter: [0, '-15%'],
              fontSize: 16,
              fontWeight: 'normal',
              formatter: '{value} %',
              color: '#00FFF4'
            },
            data: [
              { value: percentage },
            ]
          },
          { // 辅助
            z: 1,
            zlevel: 1,
            name: this.chartData.name,
            type: 'gauge',
            center: ['50%', '80%'],
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 100,
            radius: '100%',
            splitNumber: 10,
            itemStyle: {
              color: '#3398DB'
            },
            pointer: {
              show: false
            },
            progress: {
              show: true,
              width: 20,
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 15,
                color: [
                  [1, '#3398DB']
                ],
              }
            },
            axisTick: {
              distance: -14,
              splitNumber: 5,
              length: 10,
              lineStyle: {
                width: 2,
                color: 'rgb(82,124,140)'
              }
            },
            splitLine: {
              distance: -23,
              length: 4,
              lineStyle: {
                width: 1,
                color: '#02694b'
              }
            },
            axisLabel: {
              show: false
            },
            detail: {
              show: false
            },
            data: [
              {value: 0,},
            ]
          }
        ]
      }

      this.chart.setOption(option)
    }
  }
}
</script>
